export const handleNotify = (
  notify: number,
  notifyViaEmail: boolean,
  notifyViaPush: boolean,
  notifyViaBrowser: boolean
): number => {
  return notifyViaEmail || notifyViaPush || notifyViaBrowser ? notify : 0;
};
